import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { MdOpenInNew } from "react-icons/md";
import { FaLink } from "react-icons/fa";
import "./linktree.css";
import ScrollToTop from "../../Components/scrollToTop/scrollToTop";
import axios from "axios";
import logo from "../../assets/imgMenu/logo_WA_Mexico1.png";
import { Link } from "react-router-dom";

function Linktree() {
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState("");

  useEffect(() => {
    getLinks();
  }, []);

  const getLinks = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_URL_BACK}/0a2b15b1a0d8d09e86d4b42d2012a091/getLinks`
      );
      const fetchedLinks = response.data.data || response.data;
      setLinks(fetchedLinks);

      // Auto-seleccionar el primer tab disponible
      if (fetchedLinks && fetchedLinks.length > 0) {
        setActiveTab(String(fetchedLinks[0].type));
      }

      setError(null);
    } catch (error) {
      console.error(error);
      setError("No se pudieron cargar los enlaces");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ScrollToTop />
      <Helmet>
        <title>Enlaces Oficiales | WA México</title>
        <meta name="description" content="Enlaces oficiales de World Archery México" />
      </Helmet>

      <div className="linktree-container">
        <div className="linktree-content">
          {/* Logo */}
          <div className="linktree-logo">
            <Link to="/">
              <img src={logo} alt="World Archery Mexico" />
            </Link>
          </div>

          {/* Header Section */}
          <div className="linktree-header">
            <h1 className="linktree-title text-white">Enlaces Oficiales</h1>
            <p className="linktree-subtitle text-white">
              Accede a las plataformas oficiales de <span className="highlight">World Archery México.</span>
              <br />
              Encuentra registros, resultados y normativas vigentes.
            </p>
          </div>

          {/* Tabs */}
          {links.length > 0 && (
            <div className="linktree-tabs">
              {[...new Set(links.map((link) => String(link.type)))].map((typeValue) => (
                <button
                  key={typeValue}
                  className={`tab-btn ${activeTab === typeValue ? "active" : ""}`}
                  onClick={() => setActiveTab(typeValue)}
                >
                  {typeValue === "1" ? "REDES SOCIALES" : typeValue === "2" ? "GENERAL" : `CATEGORÍA ${typeValue}`}
                </button>
              ))}
            </div>
          )}

          {/* Links List */}
          <div className="linktree-links">
            {loading ? (
              <div className="loading-message">
                <p>Cargando enlaces...</p>
              </div>
            ) : error ? (
              <div className="error-message">
                <p>{error}</p>
              </div>
            ) : links.length === 0 ? (
              <div className="no-links-message">
                <FaLink className="no-links-icon" />
                <p className="no-links-title">No hay enlaces disponibles</p>
                <p className="no-links-subtitle">Los enlaces oficiales se publicarán próximamente. Vuelve a consultar más tarde.</p>
              </div>
            ) : (
              (() => {
                const filteredLinks = links.filter((link) => String(link.type) === activeTab);
                if (filteredLinks.length === 0) {
                  return (
                    <div className="no-links-message">
                      <FaLink className="no-links-icon" />
                      <p className="no-links-title">Sin enlaces en esta categoría</p>
                      <p className="no-links-subtitle">Aún no se han agregado enlaces para esta sección. Intenta con otra categoría.</p>
                    </div>
                  );
                }
                return filteredLinks.map((link) => {
                  const safeLink = link.link?.startsWith("http") ? link.link : `https://${link.link}`;
                  return (
                    <a
                      key={link.id}
                      href={safeLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="link-item"
                    >
                      <div className="link-content">
                        <span className="link-icon"><FaLink /></span>
                        <span className="link-text">{link.text}</span>
                      </div>
                    </a>
                  );
                });
              })()
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Linktree;
